/* import __COLOCATED_TEMPLATE__ from './shopify.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();